import { Box } from '@mui/material';
import { useFetchData } from 'app/hooks/store';
import { AppCountersContext } from 'app/providers';
import { getUserInfo } from 'app/store/session/repository';
import isEmpty from 'lodash/isEmpty';
import { getGamesList } from 'modules/games/store/games/repository';
import React, { FC, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'shared/components/Loader';
import { useKeycloak } from '@react-keycloak/web';
import { useSocketSubscriber } from 'app/hooks/socket';
import { SocketClientMessage } from '@okletsplay/core';
import { sessionSelector } from 'app/store/session/selectors';
import { sessionReducers } from 'app/store/session/slice';
import { getTournamentActivity } from 'modules/tournament-activity/store/repository';

export const AppInit: FC = ({ children }) => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const { setOnlinePlayers } = useContext(AppCountersContext);
  const activeUser = useSelector(sessionSelector.activeUser);

  const actions = useMemo(
    () => (keycloak?.authenticated ? [getUserInfo(), getGamesList()] : [getGamesList()]),
    [keycloak?.authenticated]
  );

  const tournamentActivityActions = useMemo(
    () => (keycloak?.authenticated ? [getTournamentActivity()] : []),
    [keycloak?.authenticated]
  );

  const { loading, fetch } = useFetchData(actions);
  const { fetch: fetchTournamentActivity } = useFetchData(tournamentActivityActions);

  const subscriptions = useMemo(
    () => [
      {
        action: SocketClientMessage.User,
        handler: () => fetch(false),
      },
      {
        action: SocketClientMessage.ActiveUserCount,
        handler: setOnlinePlayers,
      },
      {
        action: SocketClientMessage.TournamentActivity,
        handler: () => fetchTournamentActivity(false),
      },
    ],
    [fetch, fetchTournamentActivity, setOnlinePlayers]
  );

  useSocketSubscriber(subscriptions);

  useEffect(() => {
    if (!keycloak?.authenticated && !isEmpty(activeUser)) {
      dispatch(sessionReducers.resetState());
      window.localStorage.clear();
    }
  }, [activeUser, dispatch, keycloak?.authenticated]);

  if (loading) {
    return (
      <Box height="100%" width="100%" position="absolute">
        <Loader />
      </Box>
    );
  }

  return <>{children}</>;
};
